import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'wiedemann',
} as IModuleProps;
